import { Box } from "@mui/material";
import { LlamaIcon } from "~/assets/icons";

const EmptyState = ({ label = "Nothing to see here", labelStyles = {} }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      flex="1"
      height="100%"
      minHeight={300}
    >
      <LlamaIcon width={54} color="#ccc" />
      <Box fontSize="18px" color="grey.500" mt={2} fontStyle="italic" {...labelStyles}>
        {label}
      </Box>
    </Box>
  );
};

export default EmptyState;
